import { queryOptions, useQuery } from '@tanstack/react-query';

import { draftOrdersApi } from '../api/draft-orders-api';

import { draftOrderKeys } from './draft-order-keys';

export function draftOrderQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: draftOrderKeys.detail(storeId, id),
    queryFn: () => draftOrdersApi.get(storeId, id),
  });
}

export function useDraftOrder(storeId: string, id: string) {
  return useQuery(draftOrderQueryOptions(storeId, id));
}
